/**
 * GENERATED FILE - DO NOT EDIT DIRECTLY.
 * Regenerate with: npm run functions:regions
 */

export const OPS_CALLABLE_REGION = 'asia-south2'

export const OPS_CALLABLE_HANDLERS: ReadonlySet<string> = new Set([
  'acceptConMeasurement',
  'acknowledgeOnCall',
  'acknowledgeRequest',
  'acknowledgeRoster',
  'addCapaItems',
  'addConTestResult',
  'addCorrection',
  'addDiaryEntry',
  'addGang',
  'addHospitalComplianceStarters',
  'applyOpsPhoneRecommendedSet',
  'approveDpr',
  'approveRecord',
  'approveTemplateVersion',
  'archiveBookable',
  'archiveBookingPlan',
  'archiveComplianceItem',
  'archiveCoverageRule',
  'archiveCustomer',
  'archiveDepartment',
  'archiveDutyRole',
  'archiveNarcItem',
  'archivePlace',
  'archiveSchedule',
  'archiveShift',
  'archiveWorker',
  'assignRelief',
  'assignRequest',
  'assignRooms',
  'attachBmwPickupReceipt',
  'attachColdBoxPhoto',
  'attachComplianceEvidence',
  'attachConIssuePhotos',
  'attachRequestPhotos',
  'backfillOpsPlaceReadAccess',
  'bookInHouseExtra',
  'bookSession',
  'bookingCheckInByPlaceQr',
  'bulkCreatePlaces',
  'callNextToken',
  'cancelBooking',
  'cancelConMeasurement',
  'cancelLegalHoldLift',
  'cancelLostFoundClaim',
  'cancelMembership',
  'cancelRequest',
  'cancelRosterChange',
  'checkInByCustomerQr',
  'checkInByPhoneOtp',
  'checkInByPlaceQr',
  'checkInHosVisit',
  'checkOutHosVisit',
  'checkOutRoom',
  'clearBookingBlock',
  'closeConIssue',
  'closeUatRound',
  'coSignRecord',
  'commentApproval',
  'completeCapaItem',
  'completeLostFoundReturn',
  'confirmBmwHandover',
  'confirmGuestExtraRequest',
  'confirmIvfWitnessStep',
  'confirmLegalHoldLift',
  'confirmSampleHandover',
  'correctBmwDay',
  'correctConMeasurement',
  'createAsset',
  'createBookable',
  'createBookingPlan',
  'createChangeRequest',
  'createComplianceItem',
  'createConDrawing',
  'createConIssue',
  'createConProject',
  'createConTest',
  'createCoverageRule',
  'createDepartment',
  'createDeviceEnrolCode',
  'createDutyRole',
  'createEngagement',
  'createHomeCollectionJob',
  'createHosPatient',
  'createIvfWitnessStep',
  'createJobOrder',
  'createJobSite',
  'createNarcItem',
  'createOpsConnector',
  'createOutsideApproval',
  'createParty',
  'createPlace',
  'createPlaceToken',
  'createRoster',
  'createSampleBag',
  'createSchedule',
  'createShift',
  'createStaysPmsConnection',
  'createTeleOrder',
  'createTeleSession',
  'createWorker',
  'decideApproval',
  'decideAttendanceCorrection',
  'decideClientPortalApproval',
  'decideConIssue',
  'decidePeerProxyMark',
  'decideRosterChange',
  'declineGuestExtraRequest',
  'deleteOpsConnector',
  'deleteStaysPmsConnection',
  'describeLostClaim',
  'disputeConMeasurement',
  'endAllocation',
  'enrolSharedDevice',
  'ensureClinicsStarterSet',
  'exportDeliveryCsv',
  'exportNarcRegister',
  'exportOpsCsv',
  'exportOpsWageSheetCsv',
  'finalizeSharedDeviceUpload',
  'findCustomerByPhone',
  'freezeMembership',
  'getApprovalLinkInfo',
  'getBmwHandoverInfo',
  'getBmwStatus',
  'getBmwSummary',
  'getClientLinkEvents',
  'getClientLinkInfo',
  'getConIssue',
  'getConIssuePhotoUrls',
  'getConMeasureTotals',
  'getConMeasurement',
  'getConPourCard',
  'getConProject',
  'getConReport',
  'getConStarterStatus',
  'getDpr',
  'getEvidenceExportDownload',
  'getFormFPrecheck',
  'getGuestRequestStatus',
  'getGuestRoomForm',
  'getHomeCollectionAddress',
  'getHosPatient',
  'getHosPatientSettings',
  'getHosStarterStatus',
  'getHubSpokeScores',
  'getIncident',
  'getIncidentSettings',
  'getLostClaimLinkInfo',
  'getLostFoundClaimant',
  'getMyBookingQr',
  'getMyOpsPhoneItems',
  'getMyStaffStatus',
  'getOnCallBoard',
  'getOpsConnectorStatus',
  'getOpsWageSheetStatus',
  'getOwnerFeed',
  'getOwnerFeedLinkInfo',
  'getPlaceScanContext',
  'getPlantDowntimeReport',
  'getPlantStarterStatus',
  'getPublicBookingInfo',
  'getQueueBoard',
  'getRetentionLockSummary',
  'getRxPhotoUrl',
  'getSampleBag',
  'getSampleHandoverInfo',
  'getSampleSettings',
  'getStaysEngineeringReport',
  'getStaysGroupView',
  'getStaysHousekeepingReport',
  'getStaysPmsStatus',
  'getStaysStarterStatus',
  'getTeleSessionPublicInfo',
  'grantMembership',
  'guestStillAProblem',
  'holdQueueToken',
  'importAttendanceCsv',
  'importOpsCsv',
  'importStaysPmsReport',
  'importTempLog',
  'inspectRoom',
  'isolateAsset',
  'issueClientLinks',
  'issueConDrawingRevision',
  'issueQueueToken',
  'issueSharedDeviceUploadUrl',
  'leaveWaitlist',
  'linkGoalToEngagement',
  'linkMyCustomerRecord',
  'listAssetReadings',
  'listBedEvents',
  'listChurnCalls',
  'listClientLinks',
  'listConDrawingRevisions',
  'listConDrawings',
  'listConIssueDecisions',
  'listConIssues',
  'listConMeasurements',
  'listConParties',
  'listConPourCards',
  'listConProjects',
  'listConTests',
  'listCustomerContacts',
  'listDialyzers',
  'listDiaryEntries',
  'listDisputedConMeasurements',
  'listDprs',
  'listHosPatients',
  'listIncidents',
  'listIvfWitnessQueue',
  'listJobBoard',
  'listJobOrders',
  'listMyOnCallSlots',
  'listMyPublicBookings',
  'listNarcCounts',
  'listNarcItems',
  'listNarcMoves',
  'listOwnerDigests',
  'listQueueTokens',
  'listRenewalsDue',
  'listRequestKinds',
  'listSampleBags',
  'listSealedArchives',
  'listSharedDevicePeople',
  'listSharedDeviceSessions',
  'listSharedDevices',
  'listStaffStatus',
  'listTeleSessions',
  'lockOpsWageSheet',
  'logFoundItem',
  'manualCheckIn',
  'markAttendanceRoll',
  'markRequestDone',
  'markRoomCleaned',
  'markRoomOccupied',
  'markTokenServed',
  'moveBooking',
  'moveFoundItemBin',
  'movePlace',
  'openApproval',
  'openClientLink',
  'openClientPortalApproval',
  'openLostClaim',
  'openOwnerFeed',
  'pauseRoomClean',
  'pauseSchedule',
  'prepareApprovalOtp',
  'prepareBmwHandoverOtp',
  'prepareBookingCheckInOtp',
  'prepareClientLinkOtp',
  'prepareLostClaimOtp',
  'prepareOwnerFeedOtp',
  'prepareRoomCleanRecord',
  'prepareSampleHandoverOtp',
  'prepareTeleConsentOtp',
  'previewOpsWageSheet',
  'previewRosterWarnings',
  'proposeLostFoundDisposal',
  'proxyCoSignRecord',
  'proxyMarkByColleague',
  'publicBookSession',
  'publicCancelBooking',
  'publishRoster',
  'pushStaysGroupTemplate',
  'raiseGuestRequest',
  'raiseRequest',
  'raiseRevisit',
  'reassignConInspector',
  'reassignRoom',
  'receiveSamplesAtLab',
  'recomputeEngagementMargin',
  'recordAssetReadings',
  'recordAssetServiceVisit',
  'recordBmwPickup',
  'recordCheckpointScan',
  'recordConInspectionOutcome',
  'recordCustomerCall',
  'recordDialyzerUse',
  'recordDuePaid',
  'recordEffectiveness',
  'recordFoundItemPhoto',
  'recordHosConsent',
  'recordNarcMove',
  'recordOpsRestrictedView',
  'recordRunnerPing',
  'registerDialyzer',
  'reissueApproverLink',
  'reissueClientLink',
  'reissueLostFoundClaimLink',
  'reissueOwnerFeedLink',
  'releaseAsset',
  'removeFeedOwner',
  'renameDepartment',
  'renamePlace',
  'renewComplianceItem',
  'renewMembership',
  'reopenRequest',
  'repairOpsPlaceReadAccess',
  'replayOpsConnectorEvent',
  'reportIncident',
  'requestAttendanceCorrection',
  'requestConInspection',
  'requestEvidenceExport',
  'requestLegalHoldLift',
  'requestRosterChange',
  'requestSealedArchiveExport',
  'resetSharedDevicePin',
  'resolvePlaceToken',
  'respondConIssue',
  'respondRosterChange',
  'restoreFromRetentionBin',
  'resumeRoomClean',
  'resumeSchedule',
  'retireAsset',
  'retryStaysPmsOutbox',
  'returnDpr',
  'returnRecord',
  'reviewDpr',
  'reviewIncident',
  'reviewRecord',
  'revokeClientLink',
  'revokeOutsideApproval',
  'revokePlaceToken',
  'revokeSharedDevice',
  'rotateOpsConnectorSecret',
  'rotateStaysPmsSecret',
  'saveBmwDay',
  'saveConMeasurement',
  'saveConPourCard',
  'saveDprDraft',
  'saveDraftAssignments',
  'saveTemplateDraft',
  'scheduleJob',
  'sendChangeRequest',
  'sendConIssueForApproval',
  'sendOwnerDigestNow',
  'sendUatSignoff',
  'setApprovalSettings',
  'setAssetStatus',
  'setBedState',
  'setBmwSettings',
  'setChangeRequestPrice',
  'setClientUatResult',
  'setConProjectApprovers',
  'setConProjectPackages',
  'setEngagementClientApprovers',
  'setEngagementFinance',
  'setEngagementMilestones',
  'setEngagementStatus',
  'setHosPatientDirectoryEnabled',
  'setHosPatientLegalSetup',
  'setHosPatientNotice',
  'setIncidentSettings',
  'setLegalHold',
  'setLostFoundSettings',
  'setMySharedDevicePin',
  'setOpsPhonePersonAccess',
  'setOpsPhoneRoleAccess',
  'setOpsPrivacySettings',
  'setOpsWageRate',
  'setOwnerFeed',
  'setPartyMembers',
  'setPlaceAccess',
  'setPlaceDutyChain',
  'setPlacePreset',
  'setPlantNearMissExportPeople',
  'setPropertyGuestRequestsEnabled',
  'setPropertyMinibarCheck',
  'setPropertyRoomTypes',
  'setPublicBookingLink',
  'setRetentionSettings',
  'setRoomDueOut',
  'setRoomService',
  'setRoomTags',
  'setRoomType',
  'setSampleSettings',
  'setSectorRoles',
  'setSharedDevicePinByPhone',
  'setSharedDeviceSettings',
  'setStaffStatus',
  'setUatResult',
  'sharedDeviceSwitchIn',
  'sharedDeviceSwitchOut',
  'signLostFoundDisposal',
  'skipDue',
  'skipToken',
  'startBmwHandover',
  'startLostFoundClaim',
  'startNarcCount',
  'startRequest',
  'startRoomClean',
  'startSampleHandover',
  'startTeleSession',
  'startUatRound',
  'submitBmwDay',
  'submitConMeasurement',
  'submitDpr',
  'submitNarcTally',
  'submitRecord',
  'submitSharedDeviceQueued',
  'submitTeleConsent',
  'submitTemplateVersion',
  'testStaysPmsEzeeConnection',
  'testStaysPmsHotelogixConnection',
  'unassignRoom',
  'unfreezeMembership',
  'unlinkGoalFromEngagement',
  'unlockOpsWageSheet',
  'updateAsset',
  'updateBookable',
  'updateBookingPlan',
  'updateChangeRequest',
  'updateComplianceItem',
  'updateConIssue',
  'updateConProject',
  'updateCoverageRule',
  'updateDutyRole',
  'updateEngagement',
  'updateHosPatient',
  'updateJobOrderStage',
  'updateJobSite',
  'updateOpsConnector',
  'updateParty',
  'updateSchedule',
  'updateShift',
  'updateStaysPmsConnection',
  'updateWorker',
  'upsertAllocation',
  'upsertConParty',
  'upsertCustomer',
  'upsertRequestKind',
  'upsertUatChecklist',
  'verifyLostFoundClaim',
  'verifyRequest',
  'waiveDue',
  'waiveStrike',
  'withdrawChangeRequest',
  'withdrawConDrawing',
  'withdrawConIssue',
  'withdrawHosConsent',
  'withdrawLostFoundDisposal',
])

export const OPS_CALLABLE_FUNCTIONS = OPS_CALLABLE_HANDLERS
